import { useNavigate } from "react-router-dom";
import styles from "./Attorney.module.css";
import { attorneys } from "../../data/attorneys";

const AttorneysPage = () => {
  const navigate = useNavigate();

  const handleCardClick = (attorneyId) => {
    navigate(`/attorney/${attorneyId}`);
  };

  return (
    <>
      <div className={styles.attorneyRow}>
        {attorneys.map((attorney, index) => (
          <div
            key={index}
            className={styles.attorneyCard}
            onClick={() => handleCardClick(attorney.id)}
          >
            <img src={attorney.image} alt={attorney.name} />
            <h3>{attorney.name}</h3>
            <p className={styles.role}>{attorney.role}</p>
            <p className={styles.tapHint}>Click to view full profile</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default AttorneysPage;
